export default __webpack_public_path__ + "static/media/currency-icon-bw.cfca63f4.svg";